<!--
  TeIfDialogComponent Template
  ============================
  Dialog for inserting FreeMarker conditional constructs (IF/ELSE).
  Shows context-aware condition options based on dataType and mode.
  Includes a live code preview of the generated FreeMarker code.
-->

<p-dialog [header]="dialogTitle"
          [visible]="visible"
          (visibleChange)="onVisibleChange($event)"
          (onHide)="handleCancel()"
          [modal]="true"
          [style]="{width: '500px'}"
          [draggable]="false">

  <!-- Options list -->
  <div class="te-if-options">
    @for (option of availableOptions; track option.id) {
      <div class="te-if-option"
           [class.selected]="selectedOption === option.id"
           (click)="selectOption(option.id)">
        <h4>{{ option.label }}</h4>
        <p>{{ option.description }}</p>

        <!-- Text input for 'equals' option -->
        @if (option.id === 'equals' && selectedOption === 'equals') {
          <div class="mt-2">
            <input pInputText
                   [(ngModel)]="equalsValue"
                   (ngModelChange)="updatePreview()"
                   placeholder="Wert eingeben"
                   class="w-full text-sm">
          </div>
        }
      </div>
    }
  </div>

  <!-- Live Code Preview -->
  @if (generatedCode) {
    <div class="te-if-preview mt-3">
      <div class="te-if-preview-header">Vorschau</div>
      <pre class="te-if-preview-code">{{ generatedCode }}</pre>
    </div>
  }

  <!-- Footer buttons -->
  <ng-template pTemplate="footer">
    <p-button label="Abbrechen" severity="secondary" (onClick)="handleCancel()"></p-button>
    <p-button [label]="submitButtonLabel" (onClick)="handleSubmit()" [disabled]="!selectedOption"></p-button>
  </ng-template>

</p-dialog>
